import moment from 'moment';

function FormatDateTimeFilter() {
    return function(value, format) {
        if (!value) {
            return '';
        }
        format || (format = 'DD/MM/YYYY HH:mm');
        return moment(value).format(format);
    };
}

export default FormatDateTimeFilter;
